<template>
  <generic-modal
    size=""
    :title="$t('account transaction module configuration')"
    icon="settings"
    image="/images/icons/accounts.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    :show_ok="false"
    :show_cancel="false"
  >
    <div class="description">
      <div class="ui top attached tabular menu">
        <a class="active item" data-tab="types">{{
          $t("transaction types")
        }}</a>
        <a class="item" data-tab="settings">{{ $t("settings") }}</a>
      </div>
      <div class="ui bottom attached tab segment" data-tab="settings">
        <settings @close="destroy" />
      </div>
      <div class="ui bottom attached active tab segment" data-tab="types">
        <transaction-types />
      </div>
    </div>
  </generic-modal>
</template>

<script>
// import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import TransactionTypes from "./TransactionTypes";
import Settings from "./Settings";

export default {
  components: {
    "generic-modal": GenericModal,
    TransactionTypes,
    Settings,
  },
  computed: {},
  data() {
    return {
      setup: {},
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
  },
  mounted() {
    window.jQuery(".ui.menu .item").tab();
  },
  watch: {},
  updated: function() {},
};
</script>
